import { KeyboardEvent } from 'react';

const FIELD_SELECTOR =
  'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([disabled]), select:not([disabled]), textarea:not([disabled])';

/**
 * Enter w polu tekstowym przenosi kursor do następnego pola zamiast wysyłać
 * formularz. Na telefonie klawisz jest podpisany `enterKeyHint="next"`, więc
 * musi robić to, co obiecuje; na desktopie domyślne wysłanie w pół
 * wypełnionego, długiego formularza i tak kończyło się listą błędów.
 * Ostatnie pole zostawia Enter przeglądarce, czyli wysyła.
 */
export const focusNextFieldOnEnter = (event: KeyboardEvent<HTMLElement>) => {
  if (event.key !== 'Enter' || event.nativeEvent.isComposing) return;

  const target = event.target;
  if (!(target instanceof HTMLInputElement)) return;
  if (target.type === 'checkbox' || target.type === 'radio') return;

  const fields = Array.from(
    event.currentTarget.querySelectorAll<HTMLElement>(FIELD_SELECTOR),
  );
  const next = fields[fields.indexOf(target) + 1];
  if (!next) return;

  event.preventDefault();
  next.focus();
};

export default focusNextFieldOnEnter;
